import { MouseEvent, TouchEvent } from "react";
import {
  ContiguousTimeslot,
  Timeslot,
} from "@platform/features/timeslots/timeslots.types";
import { SchedulingAvailabilityTimeSlot } from "../SchedulingAvailabilityTimeSlot/SchedulingAvailabilityTimeSlot";
import SchedulingAvailabilityGridHeaderCell from "../SchedulingAvailabilityGridHeaderCell/SchedulingAvailabilityGridHeaderCell";

export type Props = {
  formattedTime: string;
  timeSlots: Timeslot[];
  selectedTimeSlots: Timeslot[];
  contiguousTimeslots: ContiguousTimeslot[];
  handleMouseDown: (e: MouseEvent<HTMLDivElement>, timeSlot: Timeslot) => void;
  handleMouseOver: (e: MouseEvent<HTMLDivElement>, timeSlot: Timeslot) => void;
  handleTouchStart: (e: TouchEvent<HTMLDivElement>, timeSlot: Timeslot) => void;
  handleTouchMove: (e: TouchEvent<HTMLDivElement>, timeSlot: Timeslot) => void;
  handleTouchEnd: (e: TouchEvent<HTMLDivElement>, timeSlot: Timeslot) => void;
  timeIndex: number;
};

export function SchedulingAvailabilityGridTimeRow({
  formattedTime,
  timeSlots,
  selectedTimeSlots,
  contiguousTimeslots,
  handleMouseDown,
  handleMouseOver,
  handleTouchStart,
  handleTouchMove,
  handleTouchEnd,
  timeIndex,
}: Props) {
  return (
    <div role="row" aria-rowindex={timeIndex} className="contents">
      {/* Time label (only for full hours) */}
      <SchedulingAvailabilityGridHeaderCell
        className="border-r sticky left-0 bg-brand-50 z-30 !touch-auto"
        role="rowheader"
      >
        {!formattedTime.includes("30") ? formattedTime : ""}
      </SchedulingAvailabilityGridHeaderCell>

      {/* Time slots for each day */}
      {timeSlots.map((timeSlot, idx) => {
        const isSelected = selectedTimeSlots
          .map((slot) => slot.id)
          .includes(timeSlot.id);

        const isFirstSlotInContiguousBlock = contiguousTimeslots.some(
          (slot) => slot.startTimeSlotId === timeSlot.id
        );

        const matchingSlot = contiguousTimeslots.find(
          (slot) =>
            timeSlot.id >= slot.startTimeSlotId &&
            timeSlot.id <= slot.endTimeSlotId
        );

        return (
          <SchedulingAvailabilityTimeSlot
            key={timeSlot.id}
            timeSlot={timeSlot}
            isSelected={isSelected}
            isFirstSlotInContiguousBlock={isFirstSlotInContiguousBlock}
            matchingSlot={matchingSlot}
            onMouseDown={handleMouseDown}
            onMouseOver={handleMouseOver}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
            dayIndex={idx}
            timeIndex={timeIndex}
          />
        );
      })}
    </div>
  );
}

export default SchedulingAvailabilityGridTimeRow;
